import { FormattedMessage, useIntl } from 'react-intl';
import { useAuth } from '@kiwicom/nitro/lib/services/auth/context';
import { useRouter } from 'next/router';
import { useBrand } from '@kiwicom/nitro/lib/services/brand/context';
import { Illustration, Box, Heading, Text, Button, ButtonLink } from '@kiwicom/orbit-components';
import { events, useLogOnMount } from '@kiwicom/account-tracking';

const AustralianUserErrorScreen = () => {
  const intl = useIntl();
  const { locale } = intl;
  const { onOpenModal } = useAuth();
  const { push } = useRouter();
  const { name: brandName } = useBrand();

  useLogOnMount(events.referFriend.SHOWED_ERROR_SCREEN, {
    errorType: 'ReferFriendNotEligibleError',
  });

  const onOpenSignUp = () => {
    onOpenModal({
      initialScreen: 'intro',
      onSignInFulfill: () => {
        void push(`/${locale}/user?action=triggerOnboarding`);
      },
    });
  };

  return (
    <Box
      display="flex"
      direction="column"
      maxWidth="1024px"
      className="mx-auto px-800 h-lvh justify-between lm:justify-center items-center"
    >
      <Box display="flex" align="center" className="flex-col-reverse lm:flex-row flex-[2]">
        <Box display="flex" direction="column" className="flex-[2]" maxWidth="415px">
          <Heading spaceAfter="medium" type="title2">
            <FormattedMessage
              id="account_v2.refer_friend.australian_user.title"
              defaultMessage="Sorry, friend referrals are not available in Australia yet"
              description="Figma: https://www.figma.com/file/3RibGwfx31SJ0UdWk3Xmku/%5BAccount%5D-Refer-a-friend?type=design&node-id=6310-52875&mode=dev"
            />
          </Heading>
          <Text size="large" spaceAfter="large">
            <FormattedMessage
              id="account_v2.refer_friend.australian_user.description"
              defaultMessage="But thank you for your interest in {COMPANY_NAME}! You can still create an account and book amazingly cheap flights. We'd be thrilled to have you on board!"
              description="Figma: https://www.figma.com/file/3RibGwfx31SJ0UdWk3Xmku/%5BAccount%5D-Refer-a-friend?type=design&node-id=6310-52875&mode=dev"
              values={{
                COMPANY_NAME: brandName,
              }}
            />
          </Text>

          <Box
            display="flex"
            align="center"
            textAlign="center"
            justify="center"
            className="flex-1"
            direction="column"
            tablet={{ direction: 'row', textAlign: 'start', justify: 'start' }}
          >
            <Box className="w-full tb:w-[160px] text-center mb-400 tb:mb-0">
              <Button onClick={onOpenSignUp} fullWidth>
                <FormattedMessage
                  id="account_v2.refer_friend.landing_page.button.create_account"
                  defaultMessage="Create account"
                />
              </Button>
            </Box>
            <ButtonLink href={`/${locale}`}>
              <FormattedMessage
                id="account_v2.component.go_to_search_button"
                defaultMessage="Go to search"
                description="Figma: https://www.figma.com/file/3RibGwfx31SJ0UdWk3Xmku/%5BAccount%5D-Refer-a-friend?type=design&node-id=6315-52892&mode=dev"
              />
            </ButtonLink>
          </Box>
        </Box>
        <Box display="flex" className="flex-[2] mb-0" justify="center">
          <Illustration name="Error404" size="display" />
        </Box>
      </Box>
    </Box>
  );
};

export default AustralianUserErrorScreen;
